import React from "react";
import { string, func, bool } from "prop-types";

import Button from "../../atoms/Button";
import { ResetPasswordModal } from "../reset-password-modal";
import "./password-update.m.css";
import { PASSWORD_UPDATE_CONTENT } from "../../../constants";

export const PasswordUpdate = ({
  onResetPassword,
  isModalOpen = false,
  onModalOpen,
  onModalClose,
  className = "",
  ...props
}) => {
  const handleResetClick = () => {
    if (onModalOpen) {
      onModalOpen();
    }
    if (onResetPassword) {
      onResetPassword();
    }
  };

  const handleCloseModal = () => {
    if (onModalClose) {
      onModalClose();
    }
  };

  return (
    <>
      <div styleName="password-section" className={className} {...props}>
        <div styleName="section-header">
          <h2 styleName="section-title">{PASSWORD_UPDATE_CONTENT.SECTION_TITLE}</h2>
        </div>

        <div styleName="password-content">
          <p styleName="description">
            {PASSWORD_UPDATE_CONTENT.DESCRIPTION}
          </p>

          <Button
            variant="dark"
            onClick={handleResetClick}
            styleName="reset-button"
          >
            {PASSWORD_UPDATE_CONTENT.RESET_BUTTON_TEXT}
          </Button>
        </div>
      </div>

      <ResetPasswordModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};

PasswordUpdate.propTypes = {
  onResetPassword: func,
  isModalOpen: bool,
  onModalOpen: func,
  onModalClose: func,
  className: string
};